import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  class: "qtl-job-status__text"
}

import { computed } from "vue";
import { JobStatus, TableDataCellDisplayType } from "@/models/etc/types";
import { i18n } from "@/i18n";
import quasarDate from 'quasar/src/utils/date/date.js';;
import type {
  CellDataJobStatus,
  CellDataJobText,
  TableDataCell,
} from "@/models/interfaces/entity-settings/querytable/querytable";

interface JobTextRow { lines: string[]; }
interface JobStatusRow { text: string; color: string; mode: number; }


export default /*@__PURE__*/_defineComponent({
  __name: 'JobCellElementLite',
  props: {
    element: {}
  },
  setup(__props: any) {

const props = __props;

const t = (k: string) => i18n.global.t(k);

const jobTextRows = computed<JobTextRow[]>(() => {
  if (props.element.DisplayType !== TableDataCellDisplayType.JobText) return [];
  return (props.element.Data as CellDataJobText[]).map((cell) => {
    const lines: string[] = [];
    if (cell.Additions && cell.Additions.length) {
      cell.Additions.forEach((add: any) => {
        let text =
          cell.Text +
          "<br/>" +
          '<span style="color: green; font-weight: medium;">' +
          (add.Creator && add.Creator.Id ? " " + add.Creator.Name : "") +
          "</span>" +
          (add.Date
            ? ' <span style="color: green;">' +
              quasarDate.formatDate(new Date(add.Date), "HH:mm DD.MM.YYYY")
            : "") +
          "</span>" +
          '<br/><span style="font-weight: bold;">' +
          (add.Type ? t("job_status_work") : t("job_status_finished")) +
          "</span>" +
          (add.Message ? ": " + add.Message : "");
        lines.push(text);
      });
    } else {
      lines.push(cell.Text);
    }
    return { lines };
  });
});

const jobStatusRows = computed<JobStatusRow[]>(() => {
  if (props.element.DisplayType !== TableDataCellDisplayType.JobStatus) return [];
  return (props.element.Data as CellDataJobStatus[]).map((cell) => {
    switch (cell.Status) {
      case JobStatus.Standard:
        return { text: t("job_is_record"), color: "black", mode: cell.DisplayType };
      case JobStatus.Working:
        return { text: t("job_in_progress"), color: "blue", mode: cell.DisplayType };
      case JobStatus.WaitingForCheck:
        return { text: t("job_waiting"), color: "yellow", mode: cell.DisplayType };
      case JobStatus.Completed:
        return { text: t("job_done"), color: "green", mode: cell.DisplayType };
      case JobStatus.Lost:
      default:
        return { text: t("job_expired"), color: "red", mode: cell.DisplayType };
    }
  });
});

return (_ctx: any,_cache: any) => {
  return (_ctx.element.DisplayType === 5)
    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(jobTextRows.value, (rec, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: 'jt_' + i,
          class: "qtl-job-text"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rec.lines, (line, li) => {
            return (_openBlock(), _createElementBlock("div", {
              key: li,
              class: "qtl-job-text__line",
              innerHTML: line
            }, null, 8, _hoisted_1))
          }), 128))
        ]))
      }), 128))
    : (_ctx.element.DisplayType === 9)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(jobStatusRows.value, (rec, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: 'js_' + i,
            class: "qtl-job-status"
          }, [
            (rec.mode === 1 || rec.mode === 3)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "qtl-job-status__badge",
                  style: _normalizeStyle({ backgroundColor: rec.color })
                }, null, 4))
              : _createCommentVNode("", true),
            (rec.mode === 2 || rec.mode === 3)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(rec.text), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      : _createCommentVNode("", true)
}
}

})